// The maladie field used to be free text, and people wrote whole sentences in it
// where a disease name was expected. It is now picked from this list.

export const OTHER_DISEASE = "Autre";

export const DISEASES = [
  "Respiratoire",
  "Diarrhée",
  "Nombril",
  "Otite",
  "Ulcère de la caillette",
  "Boiterie",
  OTHER_DISEASE,
];

/**
 * Turns a stored record into what the form should show.
 *
 * Records created before the list existed hold free text in `cause`. Those are
 * shown as "Autre" with the original text kept in the detail field, so nothing
 * already recorded is lost or reinterpreted.
 */
export function toFormValues(record) {
  const cause = (record && record.cause) || "";

  if (DISEASES.includes(cause)) {
    return {
      cause,
      cause_other: (record && record.cause_other) || "",
    };
  }

  return {
    cause: cause ? OTHER_DISEASE : "",
    cause_other: cause || (record && record.cause_other) || "",
  };
}

/** How a record should read wherever a disease is displayed. */
export function describe(record) {
  const { cause, cause_other } = toFormValues(record);

  if (!cause) return "—";
  if (cause === OTHER_DISEASE) {
    return cause_other ? `${OTHER_DISEASE} : ${cause_other}` : OTHER_DISEASE;
  }
  return cause;
}
